import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function FilmsAnimationPage() {
  const [selectedCategory, setSelectedCategory] = useState<string>('all');

  const videos = [
    {
      id: 1,
      name: 'Vidéo Anniversaire Personnalisée',
      description: 'Une vidéo animée magique pour célébrer l\'anniversaire de votre enfant',
      price: '49.90',
      duration: '2-3 min',
      category: 'anniversaire',
      popular: true,
      features: ['Personnages animés', 'Musique joyeuse', 'Nom et âge', 'Message personnalisé'],
      image: 'https://public.readdy.ai/ai/img_res/e80ac4de027c3be8d206b694f09f69b4.jpg',
    },
    {
      id: 2,
      name: 'Film Famille Animé',
      description: 'Transformez votre famille en personnages de dessin animé dans une aventure unique',
      price: '79.90',
      duration: '3-5 min',
      category: 'famille',
      popular: true,
      features: ['Toute la famille', 'Scénario personnalisé', 'Voix off possible', 'Qualité HD'],
      image: 'https://readdy.ai/api/search-image?query=An%20animated%20family%20video%20scene%20showing%20cartoon%20family%20characters%20on%20an%20adventure%20together%2C%20parents%20and%20children%20in%20colorful%20outfits%2C%20warm%20expressions%2C%20Pixar%20Disney%20style%2C%20simple%20gradient%20background%2C%20heartwarming%20atmosphere%2C%20professional%20animation%20quality&width=800&height=500&seq=famvideo1&orientation=landscape',
    },
    {
      id: 3,
      name: 'Invitation Vidéo Mariage',
      description: 'Une invitation animée romantique et élégante pour votre mariage',
      price: '59.90',
      duration: '1-2 min',
      category: 'evenement',
      popular: false,
      features: ['Couple animé', 'Détails événement', 'Musique romantique', 'Partage facile'],
      image: 'https://readdy.ai/api/search-image?query=A%20romantic%20animated%20wedding%20invitation%20video%20scene%20with%20couple%20characters%2C%20elegant%20flowers%20hearts%20and%20wedding%20elements%2C%20soft%20pastel%20colors%2C%20Pixar%20Disney%20style%2C%20simple%20clean%20background%2C%20magical%20romantic%20atmosphere%2C%20professional%20quality&width=800&height=500&seq=weddingvideo1&orientation=landscape',
    },
    {
      id: 4,
      name: 'Faire-part Naissance Animé',
      description: 'Annoncez l\'arrivée de bébé avec une vidéo douce et touchante',
      price: '44.90',
      duration: '1-2 min',
      category: 'evenement',
      popular: false,
      features: ['Bébé personnalisé', 'Infos naissance', 'Musique douce', 'Format réseaux sociaux'],
      image: 'https://readdy.ai/api/search-image?query=A%20sweet%20animated%20baby%20announcement%20video%20scene%20with%20cute%20baby%20character%2C%20soft%20clouds%20stars%20and%20baby%20elements%2C%20pastel%20colors%2C%20Pixar%20Disney%20style%2C%20simple%20clean%20background%2C%20tender%20joyful%20atmosphere%2C%20professional%20animation%20quality&width=800&height=500&seq=babyvideo1&orientation=landscape',
    },
    {
      id: 5,
      name: 'Aventure Héroïque Personnalisée',
      description: 'Votre enfant devient un super-héros dans une aventure épique',
      price: '69.90',
      duration: '3-4 min',
      category: 'enfant',
      popular: true,
      features: ['Super-héros personnalisé', 'Action et aventure', 'Effets spéciaux', 'Musique épique'],
      image: 'https://readdy.ai/api/search-image?query=An%20epic%20animated%20superhero%20video%20scene%20showing%20a%20child%20character%20in%20colorful%20superhero%20costume%20saving%20the%20day%2C%20action%20pose%2C%20vibrant%20colors%2C%20Pixar%20Disney%20style%2C%20simple%20background%2C%20exciting%20heroic%20atmosphere%2C%20professional%203D%20animation&width=800&height=500&seq=herovideo1&orientation=landscape',
    },
    {
      id: 6,
      name: 'Conte de Fées Animé',
      description: 'Une histoire de princesse ou prince personnalisée en vidéo magique',
      price: '64.90',
      duration: '3-4 min',
      category: 'enfant',
      popular: false,
      features: ['Personnage royal', 'Château magique', 'Créatures féeriques', 'Musique enchantée'],
      image: 'https://readdy.ai/api/search-image?query=A%20magical%20fairytale%20animated%20video%20scene%20with%20a%20child%20character%20as%20royalty%20in%20front%20of%20an%20enchanted%20castle%2C%20unicorns%20and%20fairies%2C%20pastel%20colors%2C%20sparkles%2C%20Pixar%20Disney%20style%2C%20simple%20background%2C%20enchanting%20atmosphere%2C%20professional%20quality&width=800&height=500&seq=fairytalevideo1&orientation=landscape',
    },
    {
      id: 7,
      name: 'Message Vidéo Personnalisé',
      description: 'Créez un message vidéo unique pour toute occasion spéciale',
      price: '39.90',
      duration: '1-2 min',
      category: 'autre',
      popular: false,
      features: ['Message personnalisé', 'Occasion au choix', 'Personnages animés', 'Livraison rapide'],
      image: 'https://readdy.ai/api/search-image?query=An%20animated%20personalized%20message%20video%20scene%20with%20cheerful%20characters%20delivering%20a%20special%20message%2C%20colorful%20elements%2C%20Pixar%20Disney%20style%2C%20simple%20clean%20background%2C%20warm%20friendly%20atmosphere%2C%20professional%20animation%20quality&width=800&height=500&seq=messagevideo1&orientation=landscape',
    },
    {
      id: 8,
      name: 'Vidéo Remerciement Mariage',
      description: 'Remerciez vos invités avec une vidéo animée touchante',
      price: '54.90',
      duration: '2-3 min',
      category: 'evenement',
      popular: false,
      features: ['Couple animé', 'Message de remerciement', 'Photos intégrables', 'Musique douce'],
      image: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20animated%20thank%20you%20video%20scene%20with%20couple%20characters%20expressing%20gratitude%2C%20hearts%20and%20flowers%2C%20warm%20colors%2C%20Pixar%20Disney%20style%2C%20simple%20background%2C%20touching%20atmosphere%2C%20professional%20quality%20animation&width=800&height=500&seq=thankyouvideo1&orientation=landscape',
    },
    {
      id: 9,
      name: 'Aventure Spatiale Animée',
      description: 'Explorez l\'espace dans une aventure cosmique personnalisée',
      price: '69.90',
      duration: '3-4 min',
      category: 'enfant',
      popular: true,
      features: ['Astronaute personnalisé', 'Planètes et aliens', 'Effets spatiaux', 'Musique cosmique'],
      image: 'https://readdy.ai/api/search-image?query=An%20exciting%20animated%20space%20adventure%20video%20scene%20with%20a%20child%20astronaut%20character%20exploring%20colorful%20planets%20with%20friendly%20aliens%2C%20stars%20and%20rockets%2C%20vibrant%20cosmic%20colors%2C%20Pixar%20Disney%20style%2C%20simple%20background%2C%20thrilling%20atmosphere%2C%20professional%203D%20animation&width=800&height=500&seq=spacevideo1&orientation=landscape',
    },
  ];

  const categories = [
    { id: 'all', name: 'Toutes les vidéos', icon: 'ri-film-line' },
    { id: 'anniversaire', name: 'Anniversaire', icon: 'ri-cake-3-line' },
    { id: 'famille', name: 'Famille', icon: 'ri-group-line' },
    { id: 'enfant', name: 'Enfant', icon: 'ri-user-smile-line' },
    { id: 'evenement', name: 'Événements', icon: 'ri-calendar-event-line' },
    { id: 'autre', name: 'Autres', icon: 'ri-more-line' },
  ];

  const filteredVideos = selectedCategory === 'all' 
    ? videos 
    : videos.filter(video => video.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50"></div>
        
        {/* Decorative Elements */}
        <div className="absolute top-20 left-10 text-6xl opacity-20">🎬</div>
        <div className="absolute bottom-20 right-10 text-5xl opacity-20">✨</div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 rounded-full mb-6">
                <span className="text-xl">🎥</span>
                <span className="font-quicksand font-semibold text-gray-800">
                  Films d'Animation Personnalisés
                </span>
              </div>

              <h1 className="text-6xl font-fredoka font-bold text-gray-900 mb-6 leading-tight">
                Donnez vie à vos{' '}
                <span className="bg-gradient-to-r from-purple-600 via-pink-600 to-primary-coral bg-clip-text text-transparent">
                  histoires en vidéo
                </span>
              </h1>

              <p className="text-xl font-quicksand text-gray-600 mb-8 leading-relaxed">
                Des vidéos animées professionnelles et personnalisées pour immortaliser vos moments spéciaux. Qualité cinématographique, émotions garanties.
              </p>

              {/* Features */}
              <div className="space-y-4 mb-8">
                {[
                  { icon: 'ri-movie-2-line', text: 'Animation 3D de qualité professionnelle' },
                  { icon: 'ri-music-line', text: 'Musique et effets sonores inclus' },
                  { icon: 'ri-hd-line', text: 'Format MP4 Full HD 1080p' },
                  { icon: 'ri-time-line', text: 'Livraison sous 3-5 jours ouvrés' },
                ].map((feature, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
                    className="flex items-center gap-3"
                  >
                    <div className="w-10 h-10 flex items-center justify-center bg-purple-600/10 rounded-full flex-shrink-0">
                      <i className={`${feature.icon} text-purple-600 text-lg`}></i>
                    </div>
                    <span className="font-quicksand text-gray-700">{feature.text}</span>
                  </motion.div>
                ))}
              </div>

              <Link
                to="#videos"
                className="inline-flex items-center gap-2 px-8 py-4 bg-gray-900 text-white font-quicksand font-bold rounded-full hover:shadow-soft-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <span>Découvrir nos vidéos</span>
                <i className="ri-arrow-down-line"></i>
              </Link>
            </motion.div>

            {/* Right Video Preview */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative"
            >
              <div className="relative rounded-5xl overflow-hidden shadow-soft-lg">
                <div className="w-full h-[600px]">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20cinematic%20scene%20showing%20multiple%20animated%20video%20frames%20floating%20in%203D%20space%2C%20featuring%20various%20characters%20and%20stories%2C%20film%20reels%20and%20play%20buttons%2C%20Pixar%20Disney%20animation%20style%2C%20vibrant%20colors%2C%20simple%20gradient%20background%2C%20magical%20atmosphere%2C%20professional%20quality%20illustration&width=700&height=900&seq=videosheromainimage&orientation=portrait"
                    alt="Films d'animation"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                {/* Play Button Overlay */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-24 h-24 flex items-center justify-center bg-white/90 backdrop-blur-sm rounded-full shadow-soft-lg cursor-pointer hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-5xl text-purple-600"></i>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-fredoka font-bold text-gray-900 mb-4">
              Comment créer votre vidéo ?
            </h2>
            <p className="text-xl font-quicksand text-gray-600">
              Un processus créatif en 5 étapes
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
            {[
              {
                number: 1,
                icon: 'ri-movie-line',
                title: 'Choisissez',
                description: 'Sélectionnez le type de vidéo',
              },
              {
                number: 2,
                icon: 'ri-user-settings-line',
                title: 'Personnalisez',
                description: 'Ajoutez vos informations',
              },
              {
                number: 3,
                icon: 'ri-image-add-line',
                title: 'Photos',
                description: 'Envoyez vos photos (optionnel)',
              },
              {
                number: 4,
                icon: 'ri-shopping-bag-line',
                title: 'Commandez',
                description: 'Validez votre commande',
              },
              {
                number: 5,
                icon: 'ri-download-cloud-line',
                title: 'Téléchargez',
                description: 'Recevez votre vidéo HD',
              },
            ].map((step, index) => (
              <motion.div
                key={step.number}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="relative"
              >
                <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-3xl p-6 text-center h-full">
                  <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center bg-gradient-to-br from-purple-600 to-pink-600 rounded-full shadow-colored-purple">
                    <span className="text-xl font-fredoka font-bold text-white">
                      {step.number}
                    </span>
                  </div>
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                    <i className={`${step.icon} text-3xl text-purple-600`}></i>
                  </div>
                  <h3 className="text-lg font-fredoka font-bold text-gray-900 mb-2">
                    {step.title}
                  </h3>
                  <p className="font-quicksand text-sm text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Videos Catalog Section */}
      <section id="videos" className="py-20 bg-neutral-lighter">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-5xl font-fredoka font-bold text-gray-900 mb-4">
              Nos Vidéos Animées
            </h2>
            <p className="text-xl font-quicksand text-gray-600">
              Des créations vidéo uniques pour tous vos moments spéciaux
            </p>
          </div>

          {/* Category Filter */}
          <div className="mb-12">
            <div className="flex flex-wrap gap-3 justify-center">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`px-6 py-3 rounded-full font-quicksand font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2 ${
                    selectedCategory === category.id
                      ? 'bg-gray-900 text-white shadow-soft'
                      : 'bg-white text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  <i className={`${category.icon} text-lg`}></i>
                  <span>{category.name}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Videos Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredVideos.map((video, index) => (
              <motion.div
                key={video.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="group bg-white rounded-3xl overflow-hidden shadow-soft hover:shadow-soft-lg transition-all duration-300 hover:-translate-y-2">
                  {/* Video Thumbnail */}
                  <div className="relative w-full h-64 overflow-hidden">
                    <img
                      src={video.image}
                      alt={video.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    {/* Play Button */}
                    <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors duration-300">
                      <div className="w-16 h-16 flex items-center justify-center bg-white/90 backdrop-blur-sm rounded-full shadow-soft">
                        <i className="ri-play-fill text-3xl text-purple-600"></i>
                      </div>
                    </div>
                    {/* Badges */}
                    <div className="absolute top-4 left-4 right-4 flex items-center justify-between">
                      <span className="px-3 py-1 bg-white/90 backdrop-blur-sm text-gray-900 text-xs font-quicksand font-bold rounded-full">
                        <i className="ri-time-line"></i> {video.duration}
                      </span>
                      {video.popular && (
                        <span className="px-3 py-1 bg-primary-yellow text-gray-900 text-xs font-quicksand font-bold rounded-full">
                          ⭐ Populaire
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-2">
                      {video.name}
                    </h3>
                    <p className="font-quicksand text-gray-600 text-sm mb-4 leading-relaxed">
                      {video.description}
                    </p>

                    {/* Features */}
                    <div className="mb-4 space-y-2">
                      {video.features.slice(0, 3).map((feature, idx) => (
                        <div key={idx} className="flex items-center gap-2">
                          <i className="ri-check-line text-primary-mint text-sm"></i>
                          <span className="font-quicksand text-xs text-gray-600">{feature}</span>
                        </div>
                      ))}
                    </div>

                    <div className="flex items-center justify-between mb-4">
                      <div>
                        <div className="text-xs font-quicksand text-gray-500 mb-1">
                          À partir de
                        </div>
                        <div className="text-3xl font-fredoka font-bold text-gray-900">
                          {video.price}€
                        </div>
                      </div>
                    </div>
                    <Link
                      to={`/produit/${video.id}`}
                      className="block w-full px-6 py-3 bg-gray-900 text-white font-quicksand font-semibold rounded-full group-hover:bg-purple-600 transition-all duration-300 whitespace-nowrap text-center cursor-pointer"
                    >
                      Créer ma vidéo
                    </Link>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {filteredVideos.length === 0 && (
            <div className="text-center py-20">
              <div className="text-6xl mb-4">🎬</div>
              <h3 className="text-2xl font-fredoka font-bold text-gray-900 mb-2">
                Aucune vidéo trouvée
              </h3>
              <p className="font-quicksand text-gray-600">
                Essayez une autre catégorie
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-fredoka font-bold text-gray-900 mb-4">
              Pourquoi choisir nos vidéos ?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: 'ri-movie-2-line',
                title: 'Qualité cinéma',
                description: 'Animation 3D professionnelle digne des grands studios',
                gradient: 'from-purple-400 to-purple-600',
              },
              {
                icon: 'ri-heart-3-line',
                title: 'Émotion garantie',
                description: 'Des histoires touchantes qui créent des souvenirs',
                gradient: 'from-pink-400 to-red-500',
              },
              {
                icon: 'ri-share-line',
                title: 'Facile à partager',
                description: 'Format optimisé pour tous les réseaux sociaux',
                gradient: 'from-blue-400 to-blue-600',
              },
              {
                icon: 'ri-gift-line',
                title: 'Cadeau unique',
                description: 'Un présent original qui marquera les esprits',
                gradient: 'from-yellow-400 to-orange-500',
              },
            ].map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-3xl p-8 text-center"
              >
                <div className={`w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-gradient-to-br ${benefit.gradient} rounded-2xl shadow-soft`}>
                  <i className={`${benefit.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-3">
                  {benefit.title}
                </h3>
                <p className="font-quicksand text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-purple-600 via-pink-600 to-primary-coral">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-5xl font-fredoka font-bold text-white mb-6">
              Prêt à créer votre vidéo magique ?
            </h2>
            <p className="text-xl font-quicksand text-white/90 mb-10">
              Donnez vie à vos histoires avec une animation professionnelle
            </p>
            <Link
              to="#videos"
              className="inline-flex items-center gap-3 px-10 py-5 bg-white text-gray-900 font-quicksand font-bold text-lg rounded-full hover:shadow-soft-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span>Choisir une vidéo</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}